import {
  Checkbox as MantineCheckbox,
  CheckboxProps as MantineCheckboxProps,
} from "@mantine/core"
import { IconCheck } from "@tabler/icons-react"
import { forwardRef } from "react"

import { IconIndeterminate } from "../../../icons/IconIndeterminate"
import { buildLabel } from "../utils"

export type CheckboxProps = Omit<MantineCheckboxProps, "component"> & {
  isLoading?: boolean
}

const CheckboxIcon: CheckboxProps["icon"] = ({
  indeterminate,
  ...others
}: {
  indeterminate?: boolean
  className?: string
}) =>
  indeterminate ? (
    <IconIndeterminate {...others} />
  ) : (
    <IconCheck stroke={3} {...others} />
  )

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, isLoading, required, ...props }, ref) => {
    const finalLabel = buildLabel({ label, isLoading, required })

    return (
      <MantineCheckbox
        ref={ref}
        label={finalLabel}
        icon={CheckboxIcon}
        {...props}
      />
    )
  }
)

Checkbox.displayName = "Checkbox"
